import { render, staticRenderFns } from "./AuthWrapper.vue?vue&type=template&id=bc38622c&"
import script from "./AuthWrapper.vue?vue&type=script&lang=ts&"
export * from "./AuthWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports